import _ from 'lodash';
import qs from 'qs';
import { axiosAPI } from '@/axios';

const defaultFilter = {
  status: 'any', sort: 'createdAt', programType: 'program', showSeason: true,
};

const loadPrograms = (filter) => {
  const query = qs.stringify(_.defaults(filter, defaultFilter), { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/programs${query}`);
  }
  return axiosAPI.get('/programs?status=any&showSeason=true');
};

const loadProgramByKey = (programId) => {
  return axiosAPI.get(`/programs/${programId}?playlistStatus=any&showEditor=any`);
};

const loadSeasons = (programId) => {
  return axiosAPI.get(`/programs/${programId}/season?status=any`);
};

const updateProgramByKey = (programId, newProgram) => {
  return axiosAPI.put(`/programs/${programId}`, newProgram);
};

const createProgram = (newProgram) => {
  return axiosAPI.post('/programs', newProgram);
};

const createSeason = (programId, newSeason) => {
  return axiosAPI.post(`/programs/${programId}/season`, newSeason);
};

const deleteProgram = (programId) => {
  return axiosAPI.delete(`/programs/${programId}`);
};

const loadTpbsProgram = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  return axiosAPI.get(`/import/programs${query}`);
};

const importTpbsProgram = (body) => {
  return axiosAPI.post('/import/programs', body);
};

const changeSyncStatus = (programId, body) => {
  return axiosAPI.put(`/import/programs/${programId}`, body);
};
// For Modals
const loadProgramsByPage = (page) => {
  let url = '/programs?limit=5';
  if (page) {
    url += `&page=${page}`;
  }
  return axiosAPI.get(url);
};

const searchProgramsInsideModal = (name) => {
  return axiosAPI.get(`/programs?limit=5&q=${name}`);
};

export {
  loadPrograms,
  loadProgramByKey,
  loadSeasons,
  updateProgramByKey,
  createProgram,
  deleteProgram,
  loadTpbsProgram,
  importTpbsProgram,
  changeSyncStatus,
  loadProgramsByPage,
  searchProgramsInsideModal,
  createSeason,
};
